export const ApplicantsBoardColumnContentState = {
  Cards: 'cards',
  Empty: 'empty',
  Loading: 'loading',
}
